import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentTransportOrderLoadsFacade } from './shipment-transport-order-loads.facade';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderLoadsGuard {
  constructor(private shipmentTransportOrderLoadsFacade: ShipmentTransportOrderLoadsFacade) {}

  canActivate({ queryParams }: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | boolean {
    const { transportOrderNumber } = queryParams;
    return checkStoreState(this.shipmentTransportOrderLoadsFacade, { transportOrderNumber });
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderLoadsFacade);
  }
}
